// third party
import * as yup from 'yup';

// project imports
import { validationSchema as noteValidationSchema } from 'store/app/workmgmt/note';

const validationSchema = (intl) =>
    yup
        .object()
        .shape({
            name: yup
                .string()
                .max(255, intl.formatMessage({ id: 'ui-comp-formvalidation-name-max', values: { maxValue: 255 } }))
                .required(intl.formatMessage({ id: 'ui-comp-formvalidation-name-required' })),
            description: yup.string().nullable(),
            responsible: yup
                .object()
                .shape({})
                .nullable()
                .required(intl.formatMessage({ id: 'ui-comp-formvalidation-responsible-required' })),
            priority: yup.string().nullable(),
            notes: yup.array().of(noteValidationSchema(intl)).nullable(),
            files: yup.array().of(yup.object().shape({}).nullable()).nullable(),
            tempFoldersName: yup.string().nullable()
        })
        .nullable();

export default validationSchema;
